import { Box, Button, Chip, CircularProgress, Divider, IconButton, MenuItem, TextField, Typography, useTheme } from "@mui/material";
import { useConstants } from "../hooks/UseConstants";
import CloseIcon from "@mui/icons-material/Close";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { FormattedMessage } from "react-intl";

function AdsFilter({
    onClickClose,
    onClickConfirm,
    filterWait,
    setFilterWait,
    status,
    setStatus,
    category,
    setCategory,
    activeFrom,
    setActiveFrom,
    activeUntil,
    setActiveUntil,
}) {
    const { language } = useConstants();
    const theme = useTheme();
    const isAr = language === "ar";

    const resetFilter = () => {
        setStatus("");
        setCategory("");
        setActiveFrom("");
        setActiveUntil("");
    };

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.background.paper,
                width: { xs: "92%", sm: "80%", md: "58%" },
                maxWidth: 760,
                borderRadius: 4,
                overflow: "hidden",
                boxShadow: "0 24px 60px rgba(13,53,140,0.18)",
            }}
            dir={isAr ? "rtl" : "ltr"}
        >
            <Box
                sx={{
                    px: 3,
                    py: 2.5,
                    background: "linear-gradient(135deg, #0D358C 0%, #2563eb 100%)",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2,
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <FilterAltOutlinedIcon sx={{ fontSize: 30 }} />
                    <Box>
                        <Typography variant="h6" fontWeight={800}>
                            <FormattedMessage id="filtering_ads" />
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.88 }}>
                            {isAr ? "فلترة الإعلانات حسب الحالة والنوع والفترة الزمنية." : "Filter ads by status, type, and active date range."}
                        </Typography>
                    </Box>
                </Box>
                <IconButton onClick={onClickClose} sx={{ color: "#fff", bgcolor: "rgba(255,255,255,0.12)", "&:hover": { bgcolor: "rgba(255,255,255,0.2)" } }}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box sx={{ p: 3 }}>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                    <Chip label={isAr ? "فلترة سريعة" : "Quick filter"} color="primary" variant="outlined" />
                    <Chip label={isAr ? "متوافق مع صفحة الإعلانات الجديدة" : "Matches the new ads page"} variant="outlined" />
                </Box>

                <Divider sx={{ mb: 3 }} />

                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
                    <TextField
                        select
                        fullWidth
                        size="small"
                        label={<FormattedMessage id="ads_state" />}
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        <MenuItem value=""><FormattedMessage id="all" /></MenuItem>
                        <MenuItem value="active"><FormattedMessage id="active" /></MenuItem>
                        <MenuItem value="not_active"><FormattedMessage id="stopped" /></MenuItem>
                        <MenuItem value="ended"><FormattedMessage id="finished" /></MenuItem>
                        <MenuItem value="not_started"><FormattedMessage id="not_started" /></MenuItem>
                    </TextField>

                    <TextField
                        select
                        fullWidth
                        size="small"
                        label={<FormattedMessage id="ads_type" />}
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                    >
                        <MenuItem value=""><FormattedMessage id="all" /></MenuItem>
                        <MenuItem value="course"><FormattedMessage id="course" /></MenuItem>
                        <MenuItem value="path"><FormattedMessage id="path" /></MenuItem>
                    </TextField>

                    <TextField
                        fullWidth
                        type="date"
                        size="small"
                        label={<FormattedMessage id="start_date" />}
                        value={activeFrom}
                        onChange={(e) => setActiveFrom(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />

                    <TextField
                        fullWidth
                        type="date"
                        size="small"
                        label={<FormattedMessage id="end_date" />}
                        value={activeUntil}
                        onChange={(e) => setActiveUntil(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>

                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, justifyContent: "flex-end", mt: 3 }}>
                    <Button onClick={resetFilter} variant="outlined" disabled={filterWait} sx={{ minWidth: 140 }}>
                        <FormattedMessage id="reset" />
                    </Button>
                    <Button
                        variant="contained"
                        disabled={filterWait}
                        sx={{ minWidth: 170, bgcolor: "#0D358C", "&:hover": { bgcolor: "#1d4ed8" } }}
                        startIcon={filterWait ? <CircularProgress size={18} color="inherit" /> : <FilterAltOutlinedIcon />}
                        onClick={() => {
                            setFilterWait(true);
                            onClickConfirm();
                        }}
                    >
                        {filterWait ? (isAr ? "جاري التطبيق..." : "Applying...") : <FormattedMessage id="filtering" />}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}

export default AdsFilter;